import http from './http'

export default class PageAPI {
	//获取所有套餐列表
	static packageList() {
		return http.httpGet('/lavrock/admin/enterpriseManagement/getProdSuit')
	}

	// 创建订单
	static createOrder(data) {
		return http.httpPost('/lavrock/order/createOrder', data)
	}

	// 查询订单状态：
	static updateOrderStatus(data) {
		return http.httpGet('/lavrock/order/updateOrderStatus', data)
	}

	// 订单列表
	static orderList(data) {
		return http.httpGet('/lavrock/order/list', data)
	}


	//获取用户的空间数量
	static getFtpCount() {
		return http.httpGet('/lavrock/publish/getFtpCount')
	}
	/**
	 * 域名校验
	 * 成功后判断 isNeedCreateNsy 这个字段去判断 是否需要调用查询用户可以使用的牛商云空间列表这个接口 获取detailId
	 * @param data {Object}
	 * @param data.domain {String}
	 * @param data.projectId {String}
	 * @returns {*}
	 */
	static checkMineDomain(data) {
		return http.httpGet('/lavrock/publish/checkMineDomain', data)
	}

	/**
	 * 查询用户可以使用的牛商云空间列表
	 * @param data {Object}
	 * @param data.projectId {String}
	 * @returns {*}
	 */
	static checkAndGetFtp(data) {
		return http.httpGet('/lavrock/publish/checkAndGetFtp', data)
	}

	/**
	 * 校验成功后获取牛商云ip
	 * @param data {Object}
	 * @param data.projectId {String}
	 * @param data.detailId {String} -不是必传 isNeedCreateNsy为flase不用传入
	 * @returns {*}
	 */
	static ipAddress(data) {
		return http.httpGet('/lavrock/publish/ipAddress', data)
	}

	/**
	 * 最后一步 解析
	 * @param data {Object}
	 * @param data.domain {String}
	 * @param data.projectId {String}
	 * @returns {*}
	 */
	static analysis(data) {
		return http.httpGet('/lavrock/publish/analysis', data)
	}

	/**
	 *  留下手机号码
	 * @param data {Object}
	 * @param data.projectId {String}
	 * @param data.uid {String}
	 * @param data.mobile {String}
	 * @param data.errorStatus {String}
	 * @param data.errorMessage {String}
	 * @returns {*}
	 */
	static leaveMessage(data) {
		return http.httpPost('/lavrock/publish/leaveMessage', data)
	}
	static downInvoice(data) {
		return http.httpGet('/invoice/ticket/order', data)
	}
	/**
	 * 购物车-根据suitId获取对应套餐信息
	 * @param {String} params.suitId
	 */
	static getShopingCartBySuitId(params) {
		return http.httpGet('/lavrock/product/pushShop', params)
	}
}
